<template>
  <transition name="el-fade-in-linear">
    <el-container  v-show='show'>
      <el-header class='main-header f-clearfix' height='76px'>
        <div class="main-user jdypage-dropDown-nav nav-sm f-right">
          <header-user></header-user>
        </div>
        <ul class="main-seach f-right">
          <li class="main-seach-input f-left">
            <div class="main-seach-input-inner">
              <!-- <input type="text"> -->
            </div>
          </li>
          <li class="main-seach-icon f-right">
            <!-- <i class="icon icon-search"></i> -->
          </li>
        </ul>
        <div class="main-nav f-left">
          <nav-main></nav-main>
        </div>
      </el-header>
      <el-main class='main-body'>
        <router-view></router-view>
      </el-main>
    </el-container>
  </transition>
</template>
<script>
import navMain from '@/components/nav-main'
import headerUser from '@/components/header-user'
export default {
    name: 'Main',
    components:{navMain,headerUser},
    data(){
      return {
        show:true
      }
    }
}
</script>


// WEBPACK FOOTER //
// src/views/main.vue